import { TimeZone } from "client/DateAndTime/timezones";
import { ReactElement } from "react";
import { EgnyteListItem } from "../../../Items/EgnyteListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { generateTrackingId } from "client/Misc/utils";
import { useEgnyteNavigationHandler } from "../../../Navigation/useEgnyteNavigationHandler";
import { ValidGlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/validation";

export type EgnyteItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.EgnyteItem>;
	itemIndex: number;
	isMobile: boolean;
	timezone: TimeZone;
	onDismiss?: () => void;
	onRemove: () => void;
	tabIndex: number;
};

export const EgnyteItemView = (props: EgnyteItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		isMobile,
		timezone,
		onDismiss,
		onRemove,
		tabIndex
	} = props;

	const {
		extension,
		lastModifiedDate,
		locationUrl,
		modifiedBy,
		name,
		path,
		url
	} = item.egnyteItem;

	const openHandler: () => void = useEgnyteNavigationHandler({
		url,
		recentlyOpenedItem: item
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("egnyte-item", `|${url}`)}
			onClick={openHandler}
		>
			<EgnyteListItem
				isMobile={isMobile}
				extension={extension}
				name={name}
				path={path}
				url={url}
				lastModifiedDate={lastModifiedDate}
				modifiedBy={modifiedBy}
				locationUrl={locationUrl}
				onDismiss={onDismiss}
				onRemove={onRemove}
				timezone={timezone}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
EgnyteItemView.displayName = "EgnyteItemView";